import React, { useEffect, useState } from 'react';
import { Modal } from '@mui/material';
import agilityLogo from '../../../assets/svg/agility-logo.svg';
import { AppInputField } from '../AppInputField/AppInputField';
import { DillButton } from '../Dill';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { addDmsiSupplierConnection } from '../../../redux/services/suppliersService';
import { useNavigate } from 'react-router-dom';
import { openMessageModal } from '../../../redux/globalSlices/genericSlice';
import { buildSupplierPath } from '../../../utils/helpers';

const AppDmsiConnectionModal = ({
  open,
  handleClose = () => {},
}: {
  open: boolean;
  handleClose: () => void;
}) => {
  const dispatch = useAppDispatch();
  const currentSupplier = useAppSelector((state) => state.auth.currentSupplier);
  const navigate = useNavigate();
  const [baseUrl, setBaseUrl] = useState('');
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const [errors, setErrors] = useState({
    baseUrl: '',
    loginId: '',
    password: '',
  });
  useEffect(() => {
    if (open) {
      setErrors({
        baseUrl: '',
        loginId: '',
        password: '',
      });
      setBaseUrl('');
      setLoginId('');
      setPassword('');
    }

    return () => {};
  }, [open]);

  function isValidBaseUrl(url: string) {
    try {
      const parsed = new URL(url);
      return parsed.protocol === 'https:' || parsed.protocol === 'http:';
    } catch {
      return false;
    }
  }

  const validateInputs = () => {
    const newErrors = {
      baseUrl: '',
      loginId: '',
      password: '',
    };

    let isValid = true;

    if (!baseUrl) {
      newErrors.baseUrl = 'This field is required.';
      isValid = false;
    }
    if (baseUrl && !isValidBaseUrl(baseUrl)) {
      newErrors.baseUrl = 'Invalid url. It should be a valid URL (e.g. https://api.example.com)';
      isValid = false;
    }
    if (!loginId) {
      newErrors.loginId = 'This field is required.';
      isValid = false;
    }
    if (!password) {
      newErrors.password = 'This field is required.';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleAuthorizeButtonClick = async () => {
    const isValid = validateInputs();
    if (!isValid) {
      return;
    }
    setIsLoading(true);
    const res = await dispatch(
      addDmsiSupplierConnection({
        supplierId: currentSupplier?.id || '',
        baseUrl,
        loginId,
        password,
      })
    );
    setIsLoading(false);
    if (res && res.type === 'supplier/addDmsiSupplierConnection/fulfilled') {
      navigate(buildSupplierPath(currentSupplier?.id, '/customers?success=true'));
      navigate(0);
    } else {
      let errorMessage = '';
      if (res.type === 'supplier/addDmsiSupplierConnection/rejected') {
        errorMessage = res.payload as any;
      }
      dispatch(
        openMessageModal({
          buttonText: 'Close',
          modalType: 'ERROR',
          title: 'Failed to connect to Agility DMSi',
          subTitle: errorMessage || '',
          onClose: () => {},
        })
      );
    }
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <div className="flex min-h-80 w-[30vw] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg  flex-col py-4 px-3">
        <div className="flex items-center flex-col">
          <img className="w-16 object-contain rounded-full" src={agilityLogo} />
          <p className="text-sm font-bold">Agility DMSi</p>
          <p className="text-xs">Connection</p>
        </div>
        <div className="flex flex-col">
          <div className="my-1.5">
            <AppInputField
              label="Base Url"
              placeholder="https://your-company.dmsi.com"
              value={baseUrl}
              isRequired={true}
              errorText={errors.baseUrl ? errors.baseUrl : ''}
              onTextChange={(value) => {
                setBaseUrl(value);
              }}
            />
          </div>
          <div className="my-1.5">
            <AppInputField
              label="Login Id"
              value={loginId}
              isRequired={true}
              errorText={errors.loginId ? errors.loginId : ''}
              onTextChange={(value) => {
                setLoginId(value);
              }}
            />
          </div>
          <div className="my-1.5">
            <AppInputField
              label="Password"
              placeholder=""
              inputType="password"
              value={password}
              isRequired={true}
              errorText={errors.password ? errors.password : ''}
              onTextChange={(value) => {
                setPassword(value);
              }}
            />
          </div>
          <div className="flex justify-between w-full mt-4">
            <DillButton
              width={100}
              label="Cancel"
              variant="secondary"
              isDisabled={isLoading}
              onClick={handleClose}
            />
            <DillButton
              width={100}
              label="Authorize"
              isLoading={isLoading}
              onClick={handleAuthorizeButtonClick}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AppDmsiConnectionModal;
